import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { getRsvpPageEvents } from '../../../../../actions/website/entities/RsvpActions';
import { fetchGuestList } from '../../../../../actions/GuestActions';
import { showModal } from '../../../../../actions/ModalActions';
import {
  resetEntities,
  addEntity
} from '../../../../../actions/website/EntityActions';


// Components
import RsvpEdit from './RsvpEdit';
import RsvpPreview from './RsvpPreview';
import CmsPageForm from '../../CmsPageForm';
import Accordion from '../../../../common/ui/Accordion';

const RsvpContainer = ({
  page,
  pageType,
  themeKey,
  orderedIds,
  rsvpEntities,
  guests,
  getPsvpEntities,
  getGuestList,
  unloadEntities,
  openEventFormModal,
  numberOfGuests,
  numberOfEvents,
  openStartGuestListModal,
}) => {
  const isPageHidden = page && page.hidden;
  const [eventsReceived, setEventsReceived] = useState(false);
  const [guestsReceived, setGuestsReceived] = useState(false);
  const [isGotItTooltip, setIsGotItTooltip] = useState(false);

  const checkRsvpsReceived = () => setEventsReceived(true);

  const checkGuestsReceived = () => setGuestsReceived(true);

  const showGotItTooltip = () => {if (numberOfEvents === 0 && isPageHidden) setIsGotItTooltip(true)};

  const closeGotItTooltip = () => setIsGotItTooltip(false);

  const handleEventFormClose = () => {
    if (numberOfGuests === 0 && numberOfEvents === 0 ) {
      openStartGuestListModal(showGotItTooltip);
    } else {
      showGotItTooltip();
    }
  }

  useEffect(() => {
    getPsvpEntities(checkRsvpsReceived);
    getGuestList(checkGuestsReceived);

    return () => unloadEntities();
  }, []);

  return (
    <div className={`container-fluid${isPageHidden ? ' page-hidden' : ''}`}>
      {(eventsReceived && guestsReceived) && (
        <div className="row">
          <div className="column col-xs-12 col-md-5">
            <RsvpEdit
              page={page}
              isPageHidden={isPageHidden}
              themeKey={themeKey}
              orderedIds={orderedIds}
              rsvpEntities={rsvpEntities}
              openEventFormModal={() => openEventFormModal(handleEventFormClose, numberOfGuests, numberOfEvents)}
              isGotItTooltip={isGotItTooltip}
              closeGotItTooltip={closeGotItTooltip}
            />
            <Accordion
              items={[
                {
                  heading: 'Page Header',
                  body: CmsPageForm,
                  props: { page },
                },
              ]}
            />
          </div>
          <div className="column col-md-7 hidden-sm hidden-xs">
            <RsvpPreview
              pageType={pageType}
              rsvpEntities={rsvpEntities}
              guests={guests}
              openEventFormModal={() => openEventFormModal(handleEventFormClose, numberOfGuests, numberOfEvents)}
            />
          </div>
        </div>
      )}
    </div>
  );
}

RsvpContainer.propTypes = {
  page: PropTypes.shape({}),
  pageType: PropTypes.string,
  themeKey: PropTypes.string,
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  rsvpEntities: PropTypes.shape({}),
  guests: PropTypes.shape({}),
  getPsvpEntities: PropTypes.func.isRequired,
  getGuestList: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  openEventFormModal: PropTypes.func,
};

const mapStateToProps = state => ({
  orderedIds: state.website.entities.orderedIds,
  rsvpEntities: state.website.entities.byId,
  guests: state.guestList.guests,
  numberOfGuests: state.guestList.guests.orderedIds.length,
  numberOfEvents: state.website.entities.orderedIds.length,
});

const mapDispatchToProps = dispatch => ({
  getPsvpEntities: (checkRsvpsReceived) => {
    dispatch(getRsvpPageEvents()).then(checkRsvpsReceived);
  },
  getGuestList: (checkGuestsReceived) => {
    dispatch(fetchGuestList()).then(checkGuestsReceived);
  },
  unloadEntities: () => dispatch(resetEntities()),
  openEventFormModal: (handleEventFormClose, numberOfGuests, numberOfEvents) => {
    dispatch(addEntity());
    dispatch(showModal('EVENT_FORM', {
      collectRsvps: true,
      websiteEvent: true,
      formIdentifier: 'eventForm',
      handleEventFormClose,
      numberOfGuests,
      numberOfEvents,
    }, { size: 'md' }));
  },
  openStartGuestListModal: (showGotItTooltip) => dispatch(showModal('START_GUEST_LIST_MODAL', {showGotItTooltip}, { size: 'md' })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RsvpContainer);



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/Rsvp/RsvpContainer.jsx